import { http } from "../index";
import Config from "../config/config";
import { query_params } from "../helpers/params";
import _ from "lodash";

const Main = _.memoize((loader) => {
  return http.get({ url: Config.Slots.Main, loader: loader });
});
const Labels = _.memoize((loader) => {
  return http.get({ url: Config.Slots.Labels, loader: loader });
});
const LastPlayed = () => {
  return http.get({ url: Config.Slots.LastPlayed });
};
const popular = _.memoize(({ limit = 15 }) => {
  return http.get({ url: Config.Slots.Popular.replace("{limit}", limit) });
});
const PlaySlot = ({ url, params }) => {
  return http.get({ url: url.concat("&", query_params(params)) });
};
const Listener = ({ hash }) => {
  console.warn(hash);
  return http.get({
    url: Config.Slots.Listener.replace("{hash}", encodeURIComponent(hash)),
  });
};
const returnMoney = (operator) => {
  return http.get({
    url: Config.Slots.ReturnMoney.replace("{operator}", operator),
  });
};
const checkBetMarketGames = ({ name }) => {
  return http.get({
    url: Config.Slots.BetMarketGames.replace("{name}", name),
  });
};
const buyBetMarketGame = ({ id, operator, discountId }) => {
  let url = Config.Slots.BuyBetMarketGame.replace("{itemId}", id).replace(
    "{operator}",
    operator
  );
  if(discountId) url = url.concat(`&discount_id=${discountId}`);
  return http.get({
    url: url,
  });
};
export default {
  Main,
  Labels,
  LastPlayed,
  PlaySlot,
  Listener,
  popular,
  returnMoney,
  checkBetMarketGames,
  buyBetMarketGame
};
